import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FileUnknownFilledSvg from "@ant-design/icons-svg/es/asn/FileUnknownFilled";
import AntdIcon from "../components/AntdIcon";
var FileUnknownFilled = function FileUnknownFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileUnknownFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FileUnknownFilled.displayName = 'FileUnknownFilled';
}
export default /*#__PURE__*/React.forwardRef(FileUnknownFilled);